const signUpTemplate = {
  event: 'sign_up', // A default GA4 event
  redirect: null, // The unencoded value in the URL, if any, or the next step
  method: null, // One of “stubhub”, “facebook”, “apple”
  visit_guid: null, // The GUID / user_cookie_guid of the user that just signed up
  visit_email: null, // The user’s unencrypted email address in base64
  visit_first_name: null, // The user’s unencrypted first name in base64
  visit_last_name: null, // The user’s unencrypted last name in base64
  marketing_comms: null, // Whether the user opted in to marketing comms
};

export default signUpTemplate;
